import React from 'react';
import { UserCheck, UserX } from 'lucide-react';

const good = [
  'Established B2B agencies, SaaS, or consultancies',
  'Average deal size above $3K',
  'Founder-led or with an existing sales function',
  'Teams ready to take 10–25 extra sales calls per month',
  'Operators who want a system, not a hustle',
];
const bad = [
  'Pre-revenue ideas still validating their offer',
  'B2C or consumer brands selling under $500',
  "Teams that can't take calls for 60+ days",
  'Anyone looking for a "cheap SDR" rather than a system',
  'Founders who want full manual control of every send',
];

export default function FitCheck() {
  return (
    <section>
      <div className="container-x">
        <div className="section-intro">
          <span className="eyebrow reveal">Honest fit check</span>
          <h2 className="section-heading reveal reveal-delay-1" style={{ marginTop: 24 }}>
            Who this is <span className="text-gradient">actually</span> for, and who it isn't.
          </h2>
          <p className="reveal reveal-delay-2">We'd rather lose a bad-fit client on the website than waste your time on a call. Here's the filter.</p>
        </div>
        <div className="fit-grid">
          <div className="fit-card good reveal">
            <div className="icon"><UserCheck size={22}/></div>
            <h3>You're a great fit if…</h3>
            <ul>{good.map((t, i) => <li key={i}><span className="dot"/><span>{t}</span></li>)}</ul>
          </div>
          <div className="fit-card bad reveal reveal-delay-2">
            <div className="icon"><UserX size={22}/></div>
            <h3>We're probably not for you if…</h3>
            <ul>{bad.map((t, i) => <li key={i}><span className="dot"/><span>{t}</span></li>)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
}
